import { Component } from '@angular/core';
import 'ag-grid-enterprise';
import { HttpClient } from '@angular/common/http';
import { ICellRendererParams, ColDef, GridApi, RowModelType, GridOptions, ValueFormatterParams, StateUpdatedEvent } from 'ag-grid-community';
import { DeliveryReport } from '../models/delivery-report.model';
import { deliveryReportDefaultGridState } from '../default-grid-states/delivery-report-default-grid-state';
import { UserGridStateService } from '../user-grid-state.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-delivery-reports',
  templateUrl: './delivery-reports.component.html',
  styleUrls: ['./delivery-reports.component.scss']
})
export class DeliveryReportsComponent {
  private apiUrl = '/api/delivery_reports/delivery_reports.php';

  // grid options
  gridApi!: GridApi;
  public rowData!: DeliveryReport[];
  public theme: string = 'ag-theme-ulaap';
  public rowModelType: RowModelType = 'clientSide';
  public gridOptions: GridOptions = {};
  public initialState = JSON.parse(JSON.stringify(deliveryReportDefaultGridState));
  public gridReady = false;
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true, // Enable filtering
    filterParams: {
      caseSensitive: false,
      buttons: ['apply', 'clear', 'reset']
    },
    autoHeight: true,
    resizable: true
  };

  public columnDefs: ColDef[] = [
    { field: 'alternate_reference', headerName: 'Order Number', cellStyle: {'font-weight': 'bold'}, pinned: 'left'},
    { field: 'week_no', headerName: 'Week No.', filter: 'agNumberColumnFilter', 
      cellRenderer: (params: ICellRendererParams) => {
        return params.value == null ? 'N/A' : params.value;
      }
    },
    { field: 'load_start', headerName: 'Pick-up Date' , filter: 'agDateColumnFilter',
      valueGetter: params => this.formatDateString(params.data.load_start),
    },
    { colId: 'load_start_time', headerName: 'Pick-up Time', filter: false, 
      valueGetter: params => this.formatTimeString(params.data.load_start)
    },
    { field: 'appointment_date', headerName: 'Appt Date' , filter: 'agDateColumnFilter',
      valueGetter: params => this.formatDateString(params.data.load_end),
    },
    { field: 'appointment_window', headerName: 'Appt Window', filter: false},
    { colId: 'load_end_time', headerName: 'Delivery Time', filter: false,
      valueGetter: params => this.formatTimeString(params.data.load_end)
    },
    { field: 'local_time', headerName: 'Actual Delivery Date',
      filter: 'agDateColumnFilter',
      valueGetter: params => this.formatDateString(params.data.local_time),
    },
    { field: 'local_time', headerName: 'Actual Delivery Time',
      filter: false,
      valueGetter: params => this.formatTimeString(params.data.local_time)
    },
    //{ field: 'local_time', headerName: 'Actual Delivery Date 2',
    //  filter: 'agDateColumnFilter',
    //  valueGetter: params => this.formatDateString(params.data.actual_delivery)
    //},
    //{ field: 'local_time', headerName: 'Actual Delivery Time 2',
    //  filter: false,
    //  valueGetter: params => this.formatTimeString(params.data.actual_delivery)
    //},    
    { field: 'delivery_status', headerName: 'Delivery Status'},
    { field: 'delivery_status', headerName: 'On-Day?', cellRenderer: this.deliveryDayStatusFormatting},
    { field: 'delivery_status', headerName: 'On-Time?', cellRenderer: this.deliveryTimeStatusFormatting},
    { field: 'trip_number', headerName: 'Trip Number'},
    { field: 'lading_number', headerName: 'Lading Number'},
    { field: 'pool_id', headerName: 'Pool ID'},
    { field: 'lading_status', headerName: 'Lading Status'},    
    { field: 'no_of_pallets', headerName: 'Pallets', filter: 'agNumberColumnFilter'},
    { field: 'pallet_delivered', headerName: 'Pallets Delivered', filter: false},
    { field: 'no_of_cartons', headerName: 'Cartons', filter: false},
    { field: 'no_of_cartons_delivered', headerName: 'Cartons Delivered', filter: false},
    { field: 'delivery_percentage', headerName: 'Delivered Percentage', width: 150 },
    { field: 'rating', headerName: 'Delivery Rating', width: 150, cellRenderer: statusTypeFormatting, filter: 'agSetColumnFilter', 
      filterParams: {
        values: ['A', 'B', 'C', 'F'],
      }
    },
    //{ field: 'manual_checks_percentage', headerName: 'Manual Checks Percentage', width: 150 },
    //{ field: 'manual_check_rating', headerName: 'Manual Check Rating', width: 150, cellRenderer: statusTypeFormatting, filter: 'agSetColumnFilter', 
    //  filterParams: {
    //    values: ['A', 'B', 'C', 'F'],
    //  }
    //},    
    { field: 'operation_delays', headerName: 'Operation Delays', filter: false},
    { field: 'delivered_time', headerName: 'Scan Date', filter: false},    
    { field: 'barcode_reader_scanned', headerName: 'Barcode Reader Scanned', filter: false},
    { field: 'manual_checks', headerName: 'Manual Check', filter: false},
    //{ field: 'auto_check_delivered', headerName: 'Auto Check Delivered', filter: false},
    { field: 'pod_uploaded', 
      headerName: 'POD Uploaded' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        return params.value === 0 ? '❌' : '✅';
      }          
    },     
    { field: 'pod_uploaded', headerName: 'POD Uploaded', filter: false},    
    { field: 'consignee_name', headerName: 'Consignee'},
    { field: 'consignee_locality', headerName: 'Consignee City'},
    { field: 'consignee_region', headerName: 'Consignee Region'},
    { field: 'shipper_name', headerName: 'Shipper'},
    { field: 'carrier_name', headerName: 'Carrier'},
    { field: 'customer_name', headerName: 'Customer', filter: 'agSetColumnFilter',
      filterParams: {
        values: ['SPENCER GIFTS', 'SPIRIT HALLOWEEN'],
      }
    },
    { field: 'created', headerName: 'Created', filter: 'agDateColumnFilter'}
  ];

  constructor(private http: HttpClient, private gridStateService: UserGridStateService) { }

  ngOnInit() {
    this.fetchAndApplyGridState();
  }

  fetchAndApplyGridState() {
    this.gridStateService.getUserGridState('delivery_reports').subscribe((state) => {
      if (state) {
        this.initialState = state;
      }
      this.gridReady = true;
    }, error => {
      console.error('Failed to fetch grid state:', error);
      this.gridReady = true;
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.fetchData();
  }

  fetchData() {
    this.http.get<{ data: DeliveryReport[] }>('/api/delivery_reports/delivery_reports.php').subscribe(
      response => {
        this.rowData = response.data;
      },
      error => {
        console.error('Error fetching delivery report data:', error);
      }
    );
  }

  onStateUpdated(params: StateUpdatedEvent<DeliveryReport>): void {
    if (params.sources.indexOf('columnSizing') > -1 || params.sources.indexOf('columnOrder') > -1) {
      this.gridStateService.saveUserGridState('delivery_reports', params.state);
    }
  }

  exportToCSV() {
    var params = { columnSeparator: "|" }
    this.gridApi.exportDataAsCsv(params);
  }

  exportToExcel() {
    this.gridApi.exportDataAsExcel();
  }

  openStoreReports() {
    window.open('/store_reports');
  }

  openExceptionReports() {
    window.open('/exception_reports');
  }

  toggleTheme() {
    this.theme = this.theme === 'ag-theme-ulaap' ? 'ag-theme-ulaap-dark' : 'ag-theme-ulaap';
  }

  deliveryDayStatusFormatting(params: ICellRendererParams) {
    let statusTypes: string[] = []
    if (params.value != null) {
      statusTypes = params.value.split(",");
    }
    let buttonsHtml = '';
  
    for (let type of statusTypes) {
      let trimmedType = type.trim();
      let bgColor = '';
  
      if(trimmedType.toUpperCase().includes('LATE DATE')){
        trimmedType = 'LATE DATE';
        bgColor = '#FFF';
      }
      else if(trimmedType.toUpperCase().includes('EARLY DATE')){
        trimmedType = 'EARLY DATE';
        bgColor = '#FF0';
      }
      else {
        trimmedType = 'ON DATE';
        bgColor = '#0F0';
      }
  
      buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
    }
  
    let element = '<div class="btn-group">' + buttonsHtml + '</div>';
  
    return element;
  }

  deliveryTimeStatusFormatting(params: ICellRendererParams) {
    let statusTypes: string[] = []
    if (params.value != null) {
      statusTypes = params.value.split(",");
    }
    let buttonsHtml = '';

    for (let type of statusTypes) {
      let trimmedType = type.trim();
      let bgColor = '';

      if(trimmedType.toUpperCase().includes('LATE TIME')){
        trimmedType = 'LATE TIME';
        bgColor = '#FFF';
      }
      else if(trimmedType.toUpperCase().includes('EARLY TIME')){
        trimmedType = 'EARLY TIME';
        bgColor = '#FF0';
      }
      else if(trimmedType.toUpperCase().includes('EARLY DATE')){
        trimmedType = 'EARLY TIME';
        bgColor = '#FF0';
      }      
      else if(trimmedType.toUpperCase().includes('LATE DATE')){
        trimmedType = 'LATE TIME';
        bgColor = '#FFF';
      }      
      else {
        trimmedType = 'ON TIME';
        bgColor = '#0F0';
      }

      buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
    }

    let element = '<div class="btn-group">' + buttonsHtml + '</div>';

    return element;
  }
  
  private formatDateString(value: string | null): string {
    if (!value || isNaN(new Date(value).getTime())) return '';
    return value.split(' ')[0];
  }

  private formatTimeString(value: string | null): string {
    if (!value || isNaN(new Date(value).getTime())) return '';
    return new Date(value).toTimeString().split(' ')[0];
  }
}



// function for custom cell renderer for shipment types (colored)
function statusTypeFormatting(params: ICellRendererParams) {
  let statusTypes: string[] = []
  if (params.value != null) {
    statusTypes = params.value.split(",");
  }
  let buttonsHtml = '';

  for (let type of statusTypes) {
    let trimmedType = type.trim();
    let bgColor = '';

    switch (trimmedType) {
      case 'A':
        bgColor = '#33FFFF';
        break;
      case 'B':
          bgColor = '#66FF66';
          break;
      case 'C':
            bgColor = '#FFFF66';
            break;                  
      case 'F':
        bgColor = '#FF6666';
        break;
      default:
        bgColor = '#FFFFFF';
    }

    buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">&nbsp;&nbsp;' + trimmedType + '&nbsp;&nbsp;</button> <br>';
  }

  let element = '<div class="btn-group">' + buttonsHtml + '</div>';

  return element;
}

